import React from "react"
import PropTypes from "prop-types"

import SignUpContainer from "./SignUpContainer"
import CompanyStep3Form from "../../forms/SignUpForms/CompanyStep3Form"
import SignUpWizard from "../../components/SignUpWizard"

function SignUpCompanyStep3Container({
  onHandleNext,
  onBack,
  handleSaveUser,
  user,
  lockedInfo,
  initialValues,
}) {
  return (
    <SignUpContainer
      title="Sign Up Process"
      subtitle="Profile Creation"
      description="Fill up info to continue to platform"
      onBack={onBack}
      onNext={onHandleNext}
      isButtonSubmit
      useVerticalLayout={true}
      currentStep={3}
      userRole="company"
      lockedInfo={lockedInfo}
    >
      <CompanyStep3Form handleSaveUser={handleSaveUser} initialValues={initialValues} />
    </SignUpContainer>
  )
}

SignUpCompanyStep3Container.propTypes = {
  onHandleNext: PropTypes.func,
  onHandleRole: PropTypes.func,
  user: PropTypes.any,
  lockedInfo: PropTypes.array,
  initialValues: PropTypes.object,
}

export default SignUpCompanyStep3Container
